import { ReactNode, useEffect, useState } from "react";
import { Box, Collapse, Grid, Typography, Button, Tooltip } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useManageModal, useSlideInContext } from "ui";
import SendIcon from '@mui/icons-material/Send';
import { useMutation } from "@apollo/client";
import { EmailFormWrapper } from "../components/EmailFormWrapper";
import { NoteOriginType, Student, NoteTypeEnum, AddStudentNoteMutation, AddStudentNoteMutationVariables, StudentDataType, Subscription } from "ft-shared-graphql";
import { EDIT_STUDENT_PARENT_EMAIL, ADD_SESSION_NOTE_MUTATION, ADD_STUDENT_NOTE_MUTATION } from "ft-shared-graphql";
import EnlightnOptions from "./EnlightnOptions";
import { PARENT_EMAIL_ACTION, PARENT_OPTION_ACTION, PREVIEW_EMAIL_INFO, SendToParentProps } from "./SendToParentType";
function LaunchButton({ action: type, currentAction: action, onAction, width = 180, disabled, children }: {
    action: PARENT_EMAIL_ACTION,
    currentAction: PARENT_EMAIL_ACTION | null,
    onAction: (action: PARENT_EMAIL_ACTION) => {},
    children: ReactNode,
    width?: number,
    disabled?: boolean
}) {
    return (
        <LoadingButton
            sx={{
                backgroundColor: "primary.main",
                "&:hover": {
                    backgroundColor: "primary.light",
                },
                width,
                marginTop: "16px",
                padding: 1
            }}
            type="submit"
            variant="contained"
            loading={type === action}
            loadingPosition="end"
            disabled={disabled}
            endIcon={<SendIcon />}
            onClick={() => onAction(type)}
        >
            {children}
        </LoadingButton>
    )
}


export default function SendToParentOptions({ studentData, updateStudent, subscriptions, onAction }: SendToParentProps) {
    const { openModal } = useManageModal();
    const { disableClosingDrawer, toggleDrawer } = useSlideInContext();
    const [showEnlightn, setShowEnlightn] = useState<boolean>(false)
    const [launchAction, setLaunchAction] = useState<PARENT_EMAIL_ACTION | null>(null);
    const [previewInfo, setPreviewInfo] = useState<PREVIEW_EMAIL_INFO | null>(null);
    const [addStudentNoteMutation] = useMutation<AddStudentNoteMutation, AddStudentNoteMutationVariables>(ADD_STUDENT_NOTE_MUTATION);

    const handleLaunch = async (action: PREVIEW_EMAIL_INFO) => {
        // Prevent accidental closing of the application drawer
        // disableClosingDrawer(true);
        const link = document.createElement('a');

        setPreviewInfo(action);
        onAction('preview', action, [])
        // switch (action) {
        //     case "preview-general": {
        //         link.href = `${window.__env.API_URL}/api/file/download/generalParentInfo`
        //         break;
        //     }
        //     case "preview-report1": {
        //         const parentFiles = studentData.lastSession.report.filter((e: { category: string }) => e.category == "Parent-Report")
        //         //@ts-ignore
        //         const newestParentFile = parentFiles?.reduce((newest, current) => {
        //             return new Date(current.createdAt) > new Date(newest.createdAt) ? current : newest;
        //         })
        //         link.href = `${window.__env.API_URL}/api/file/download/client/parent-reports/${newestParentFile.id}`
        //         break;
        //     }
        //     default: {
        //     }
        // }
        // link.target = "_blank"
        // // Prevent potential memory leak and cleanup ObjectURL
        // // resources that are no longer in use
        // const linkHandler = () => {
        //     setTimeout(() => {
        //         link.removeEventListener('click', linkHandler);
        //         document.body.removeChild(link);
        //     }, 300);
        // }

        // link.addEventListener('click', linkHandler);
        // document.body.appendChild(link);
        // link.click()
    };

    const handleSend = async (action: PARENT_EMAIL_ACTION) => {
        // const { pid, lid } = decodedToken(accessToken ?? '');
        setLaunchAction(action)
        onAction('send', action, [])

        var res = await addStudentNoteMutation({
            variables: {
                studentId: studentData?.id,
                type: NoteTypeEnum.ParentGeneralInformationSent,
                origin: NoteOriginType.ResultsTable,
                body: `Information Sent to parent: General Information`
            }
        })
        //         showSuccessMessage();
        //         toggleDrawer()

        //         disableClosingDrawer(false)
        //         setLaunchAction(null);
        //         break;
        //     case "report1":
        //         const parentFiles = studentData.lastSession.report.filter((e: { category: string }) => e.category == "Parent-Report")
        //         //@ts-ignore
        //         const newestParentFile = parentFiles?.reduce((newest, current) => {
        //             return new Date(current.createdAt) > new Date(newest.createdAt) ? current : newest;
        //         })
        //         var response = await fetch(`${window.__env.API_URL}/api/parent/send/${newestParentFile.id}`, {
        //             method: "post",
        //             headers: {
        //                 Pid: pid,
        //                 Lid: lid,
        //                 "Content-Type": "application/json",
        //                 authorization: `Bearer ${accessToken}`,
        //             },
        //             body: JSON.stringify({
        //                 personId: pid,
        //                 studentId: studentData.id,
        //             }),
        //         })
        //         if (response.status >= 400) {
        //             showFailureMessage();
        //             disableClosingDrawer(false)
        //             setLaunchAction(null);
        //             return;
        //         }
        //         var res = await addStudentNoteMutation({
        //             variables: {
        //                 studentId: studentData.id,
        //                 type: NoteTypeEnum.ParentReportSent,
        //                 origin: NoteOriginType.ResultsTable,
        //                 body: `Information Sent to parent: Parent 1 Report`
        //             }
        //         })
        //         showSuccessMessage();
        //         toggleDrawer()

        //         disableClosingDrawer(false)
        //         setLaunchAction(null);
        //         break;
        //     case "report2":
        //     default: break;
        // }

    }
    const showSuccessMessage = () => {
        toggleDrawer();
        disableClosingDrawer(false);
        openModal({ type: "PARENT_SEND_GENERAL_INFORMATION_SUCCESS", eventType: 'DISABLE_BACKDROP', cancelButtonLabel: "Close" });
    };

    const showFailureMessage = () => {
        toggleDrawer();
        disableClosingDrawer(false);
        openModal({ type: "GENERAL_ERROR", eventType: 'DISABLE_BACKDROP', cancelButtonLabel: "Close" });
    };
    useEffect(() => {
        console.log(studentData)
    }, [studentData])

    if (!studentData?.parentEmail)
        return <EmailFormWrapper studentData={studentData} updateStudent={updateStudent} />
    const subscriptionMessage = !subscriptions.some((sub: any) => sub.name === "ENLIGHTN") ? "Not included in Subscription" : ""
    if (showEnlightn) {
        return (
            <EnlightnOptions studentData={studentData} updateStudent={updateStudent} onAction={onAction} subscriptions={subscriptions} />
        )
    }

    return (
        <Grid
            container
            spacing={1}
            direction="column"
            alignItems="center"
            sx={{ padding: "36px 16px", textAlign: "center" }}
        >
            <Grid size={12} direction="column" alignItems="center">
                <Typography sx={{ marginBottom: 2 }}>
                    The Parent Email on file is <strong>{studentData.parentEmail}</strong>
                </Typography>
            </Grid>
            <Grid size={12} direction="column" alignItems="center">
                <Typography>
                    What type of information would you like to send?
                </Typography>
                <Button sx={{
                    marginTop: "16px",
                    padding: 1
                }} variant="contained" onClick={() => handleLaunch("preview-general")}>
                    View General Information
                </Button>
                <Collapse in={previewInfo === "preview-general"}>
                    <Grid size={12} direction="column" alignItems="center">
                        <LaunchButton
                            action="general"
                            currentAction={launchAction}
                            width={210}
                            onAction={handleSend}>Send General Information to parent</LaunchButton>
                    </Grid>
                </Collapse>
                {/* We hide this so they can send info regardless of if they student has a complete session */}
                {studentData.lastSession ?
                    <>
                        <Button sx={{
                            marginTop: "16px",
                            padding: 1
                        }} variant="contained" onClick={() => handleLaunch("preview-report1")}>
                            View Parent 1 Report
                        </Button>
                        <Collapse in={previewInfo === "preview-report1"}>
                            <Grid size={12} direction="column" alignItems="center">
                                <LaunchButton
                                    action="report1"
                                    currentAction={launchAction}
                                    width={210}
                                    onAction={handleSend}>Send Parent Report to parent</LaunchButton>
                            </Grid>
                        </Collapse>
                        <Button sx={{
                            marginTop: "16px",
                            padding: 1
                        }} variant="contained" onClick={() => handleLaunch("preview-report2")} disabled>
                            Coming Soon Parent 2 Report
                        </Button>
                        <Collapse in={previewInfo === "preview-report2"}>
                            <Grid size={12} direction="column" alignItems="center">
                                <LaunchButton
                                    action="report2"
                                    currentAction={launchAction}
                                    width={210}
                                    onAction={handleSend}>Send Parent Report to parent</LaunchButton>
                            </Grid>
                        </Collapse>
                    </>
                    :
                    <></>}
            </Grid>
            <Grid size={12} direction="column" alignItems="center">
                <Tooltip title={subscriptionMessage}>
                    <Box>
                        <Button variant="contained" sx={{ marginTop: "16px", padding: 1 }}
                            disabled={!subscriptions.some((sub: any) => sub.name === "ENLIGHTN")}
                            onClick={() => setShowEnlightn(true)}
                        >
                            View TrueSage Enlightn™ Materials
                        </Button>
                    </Box>
                </Tooltip>
            </Grid>
        </Grid>
    );
}


